export default function normalizeLink(path) {
  return path
    .replace(/\/content\/sapcom\/(?:countries|languages)\/[^/]+/, '')
    .replace(/\.html$/, '');
}
